import { cardAssetId } from "../../assets/assetManifest";
import { AssetImage } from "../AssetImage";
import { SimpleCard, deckStyle } from "./SimpleCard";

const HEIGHTS = { lg: 120, bomb: 102, sm: 66, seat: 96, md: 84, burn: 50 }; // bomb: two boards, 15% smaller; seat: hole cards fanned behind an avatar; burn: the muck beside the chip rack

// `from` = [dx, dy] px: where the card flies in from (the dealer). `to` = [dx, dy] px: it flies away there (fold). Defaults to a short drop-in.
// Faces: the clean big-rank face (default) or the owner's art deck (setting pfp_deck = "art"); backs are always the art back.
export const CardView = ({ card, size = "md", delay = 0, from, to, highlight, slow = false, still = false }) => {
  const h = HEIGHTS[size] || HEIGHTS.md;
  const style = { animationDelay: `${delay}ms` };
  if (from) { style["--from-x"] = `${from[0]}px`; style["--from-y"] = `${from[1]}px`; }
  if (to) { style["--to-x"] = `${to[0]}px`; style["--to-y"] = `${to[1]}px`; }
  const cls = `rounded-md card-face select-none max-w-none ${still ? "" : to ? "fold-fly" : from ? (slow ? "lift-fly" : "deal-fly") : "deal"} ${highlight === "win" ? "card-win" : highlight === "dim" ? "card-dim" : ""}`;
  if (card !== "XX" && deckStyle() !== "art") {
    return <SimpleCard card={card} height={h} data-testid={`card-${card}`} data-highlight={highlight || undefined} className={cls} style={style} />;
  }
  return (
    <AssetImage id={cardAssetId(card)} height={h} data-testid={card === "XX" ? "card-back" : `card-${card}`} data-highlight={highlight || undefined}
      className={cls} style={style} />
  );
};
